<template>
  <div 
    class="c-rect-item"
    :class="{ 'active' : active }"
  >
    <slot name="main" :props_slot="props_slot" />
  </div>
</template>

<script>
import dTransportIdValid from '@/mixins/dTransportIdValid'
import { ClassColor } from '@/helpers/base/colors'
// Машины
import { adapterModelCarsForMap } from '@/services/adapter/cars'
import { filterOnlyCarsWithCoords, addColorCarsByRoute, carsUpdateItemsByAzimuth } from '@/helpers/cars'
// Маршруты
import { adapterModelRoutesForMap } from '@/services/adapter/routes'
import { addColorRoutes } from '@/helpers/routes'
export default {
  name: 'c-rect-item',
  mixins: [dTransportIdValid],
  props: {
    rect_id: {
      type: [Number, String],
      default: null
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cars_list: [],
      new_cars: [],
      cars_loading: false,
      requestCars: null
    }
  },
  mounted() {
    if(this.routes_by_rect.length != 0) {
      // Загружаем машины сразу
      this.fetchCars()
      // Запускаем функцию обновления данных по машинам
      this.updatedTimeoutCars()
    }
  },
  created() {
    // Проверяем не изменился ли D-Transport ID у маршрутов и обновляем их при необходимости
    for (let i = 0; i < this.routes_by_rect.length; i++) {
      const route = JSON.parse(JSON.stringify(this.routes_by_rect[i]))
      let found_route = this.all_routes.filter(function (el) {
        return el.dtransport_id === route.dtransport_id && el.route_name_and_type === route.route_name_and_type
      })[0];
      let correct_route = this.all_routes.filter(function (el) {
          return el.route_name_and_type === route.route_name_and_type
        })[0];
      if (found_route === undefined) {
        if (correct_route !== undefined) {
          this.$store.commit('RECT_ROUTES_REMOVE', {route_and_type: route.route_and_type, rect_id: route.rect_id})
          this.$store.commit('RECT_ROUTES_ADD', {rect_id: route.rect_id, ...correct_route})
        } else {
          // 'disable' route
          let correct_route = route
          correct_route.dtransport_id = null
          correct_route.value = null
          this.$store.commit('RECT_ROUTES_REMOVE', {route_and_type: route.route_and_type, rect_id: route.rect_id})
          this.$store.commit('RECT_ROUTES_ADD', {rect_id: route.rect_id, ...correct_route})
        }
      }
    }
  },
  computed: {
    routes_by_rect() {
      return this.$store.getters.RECT_ROUTES_BY_RECT_ID(this.rect_id)
    },
    all_routes() {
      return this.$store.getters.ROUTES_SELECT
    },
    routes_by_map() {
      let routes = [...this.$store.getters.ROUTES]
      let routes_by_rect = this.routes_by_rect
      // Адптируем модель данных
      let result = adapterModelRoutesForMap(routes, routes_by_rect)
      // Добавляем цвет к объектам маршрута
      result = addColorRoutes(result, this.colorRoute)
      return result
    },
    cars_by_map() {
      let result = [ ...this.cars_list ]
      // Фильтруем машины только с валидными координатами
      result = filterOnlyCarsWithCoords(result)
      // Добавляем цвет получая его из маршрута
      result = addColorCarsByRoute(result, this.routes_by_map)
      return result
    },
    props_slot() {
      return {
        routes_list: this.routes_by_map,
        cars_list: this.cars_by_map,
        cars_loading: this.cars_loading
      }
    }
  },
  watch: {
    routes_by_rect(val_new, val_old) {
      // Если добавили или удалили маршрут, сбросит таймаут и загрузит актуальные машины по маршрутам
      if(val_new.length != val_old.length) {
        this.resetTimeoutAndFetchCars()
      }
    }
  },
  methods: {
    /* Маршруты */
    colorRoute(v = { route_type: { id: null } }, routes = []) {
      const color = new ClassColor()
      try {
        let filter_by_type = routes.filter(i => i.route_type.id == v.route_type.id)
        return color.byRouteInMap(v, v.route_type.id, filter_by_type)
      } catch ({ name, message }) {
        if (name == 'TypeError') {
          console.warn("Disabled route was found.");
        }
        return color.byRouteInMap(v, null, [])
      }
    },
    /* Маршруты END */

    /* Машины */
    updatedTimeoutCars(second = 5) {
      let timeout = Number(second) * 1000
      this.requestCars = setInterval(() => {
        this.fetchCars()
      }, timeout)
    },
    resetTimeoutAndFetchCars() {
      this.stopUpdatedTimeoutCars()
      
      setTimeout(() => {
        this.cars_list = []
        this.fetchCars()
        this.updatedTimeoutCars()
      }, 100)
    },
    stopUpdatedTimeoutCars() {
      clearInterval(this.requestCars)
      this.requestCars = null
    },
    carsAddInNewCars(array, dtransport_id, route_and_type) {
      this.new_cars = [
        ...this.new_cars,
        ...adapterModelCarsForMap(array, dtransport_id, route_and_type)
      ]
    },
    carsUpdatedList() {
      this.cars_list = carsUpdateItemsByAzimuth([...this.new_cars], [...this.cars_list])
      this.new_cars = [] // очищаем, чтобы не засорять память
    },

    // API
    fetchCars() {
      let promise = []

      if(this.routes_by_rect.length != 0) {
        this.cars_loading = true
        this.new_cars = []

        promise = this.routes_by_rect.map(i => this.fetchCarsByRoute(i.dtransport_id,i.route_and_type))

        Promise.all(promise)
        .then(() => this.carsUpdatedList())
        .finally(() => this.cars_loading = false)
      } else {
        this.new_cars = []
        this.cars_list = []
      }
    },
    fetchCarsByRoute(dtransport_id, route_and_type) {
      if(this.dTransportIdValid(dtransport_id)) {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('CARS_BY_ROUTE_REQUEST', dtransport_id)
          .then(response => {
            if(response.data) {
              this.carsAddInNewCars(response.data, dtransport_id, route_and_type)
            }
            resolve(response)
          })
          .catch(error => reject(error))
        })
      }
    },
    /* Машины END */
  },
  beforeDestroy() {
    // Останавливает функцию обновления данных при уничтожении компонента
    this.stopUpdatedTimeoutCars()
  }
}
</script>

<style lang="scss">
  .c-rect-item {
    position: relative;
    width: 100%;
    height: 100%;
    background: #fff;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    z-index: 1;
    &.active {
      cursor: move;
      box-shadow: 0px 15px 35px rgba(37, 51, 66, 0.15);
    }
  }
</style>